import { Outlet, useLocation } from "react-router-dom";
import { PageEnum, TABLEPAI, BUILDING_TABLE_HEADER } from "@/enums/pageEnum";
import { useTranslation } from "react-i18next";
import { BasicTable, HView } from "@/components";

export default function Building() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  if (pathname !== PageEnum.BUILDING) {
    return <Outlet />;
  }

  return (
    <div className="p-4">
      <BasicTable
        tableColsRender={[
          {
            title: t("action"),
            dataIndex: "action",
            renderText: (_: string, record: { id: string }) => (
              <HView
                name={t("view")}
                path={`${PageEnum.BUILDING}/detail/${record?.id}`}
                state={record}
              />
            ),
          },
        ]}
        filterTableFields={[
          {
            field: "name",
            label: t("building"),
            keys: ["tc", "pfx", "blk"],
            component: "groupTexts",
            labelCol: { span: 5 },
            wrapperCol: { span: 19 },
          },
          { field: "postalCode", label: t("postalCode"), component: "text" },
        ]}
        editTableHeaderUrl={BUILDING_TABLE_HEADER}
        isShowCheckbox={false}
        tableName="building"
        headerTitle={() => t("buildingList")}
        requestUrl={TABLEPAI.BUILD_PAGE}
      />
    </div>
  );
}
